<template>
  <div>
    <div class="add-channel">
      <el-button
        type="success"
        plain
        size="small"
        icon="el-icon-circle-plus-outline"
        @click="showAdd($event)"
        >新增渠道</el-button
      >
    </div>
    <div class="table-data">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column align="center" label="序号" type="index">
          <!-- <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    <span style="margin-left: 10px">{{ scope.row.date }}</span>
                </template> -->
        </el-table-column>
        <el-table-column
          align="center"
          label="渠道号"
          prop="channel"
        ></el-table-column>
        <el-table-column
          align="center"
          label="渠道名称"
          prop="name"
        ></el-table-column>
        <el-table-column
          align="center"
          label="域名"
          prop="domain"
        ></el-table-column>
        <el-table-column
          align="center"
          label="排序"
          prop="sort"
        ></el-table-column>
        <el-table-column align="center" label="开关" prop="switch">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.switch"
              @change="changeSwitch(scope.row)"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="姓名" width="100">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>姓名: {{ scope.row.name }}</p>
                        <p>住址: {{ scope.row.address }}</p>
                        <div slot="reference" class="name-wrapper">
                            <el-tag size="medium">{{ scope.row.name }}</el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column> -->
      </el-table>
    </div>
    <ChannelAddAndEditor
      v-if="showPage"
      :showPage.sync="showPage"
      :title="title"
      :editorInfo="editorInfo"
    />
  </div>
</template>
<script>
import ChannelAddAndEditor from "./components/Channel/ChannelAddAndEditor.vue";
import {channel_list, channel_add, channel_edit, channel_delete} from "../../request/api.js"
export default {
  data() {
    return {
      tableData: [],
      showPage: false,
      editorInfo: {},
    };
  },
  components: {
    ChannelAddAndEditor,
  },
  methods: {
    handleEdit(row) {
      this.title = "渠道编辑";
      this.showPage = true;
      this.editorInfo = row;
    },
    handleDelete(row) {
      this.$confirm("是否删除该渠道号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
            action: "channel_delete",
            id: row.id,
        }
        channel_delete(params).then((res) => {
          if (res.status == 0) {
            this.$message.success(res.detail);
            this.getChannelList();
          }
        })
      });
    },
    getChannelList() {
      channel_list().then((res)=>{
          if (res.status == 0) {
            res.data.map((item) => {
              item.switch = Boolean(Number(item.switch));
            });
            this.tableData = res.data;
          } else {
            if (res.detail == "暂无数据") {
              this.$message.warning(res.detail);
              this.tableData = [];
            }
          }
      })
    },
    changeSwitch(current) {
      console.log(current);
      let params = {
        action: "channel_edit",
        id: current.id,
        switch: Number(current.switch),
      };
      channel_edit(params).then(
        (res) => {
          if (res.status == 0) {
            this.$message.success(res.detail);
            this.getChannelList();
          }
        }
      );
    },
    showAdd(e) {
      this.title = e.target.innerText;
      this.showPage = true;
      this.editorInfo = {};
    },
  },
  created() {
    this.getChannelList();
  },
};
</script>

<style lang="less" scoped>
.add-channel {
  width: 100%;
  text-align: right;
  button {
    margin-right: 5px;
  }
}
/deep/ .el-table th.el-table__cell {
  -ms-user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  user-select: text;
}
/deep/ .el-table th.el-table__cell {
  -ms-user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  user-select: text;
}
</style>
